var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWindowClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "inherit",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.295 11.115C22.6844 10.7256 22.6844 10.0944 22.295 9.705C21.9056 9.31564 21.2744 9.31564 20.885 9.705L16 14.59L11.115 9.705C10.7256 9.31564 10.0944 9.31564 9.705 9.705C9.31564 10.0944 9.31564 10.7256 9.705 11.115L14.59 16L9.705 20.885C9.31564 21.2744 9.31564 21.9056 9.705 22.295C10.0944 22.6844 10.7256 22.6844 11.115 22.295L16 17.41L20.885 22.295C21.2744 22.6844 21.9056 22.6844 22.295 22.295C22.6844 21.9056 22.6844 21.2744 22.295 20.885L17.41 16L22.295 11.115Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindowClose);
export default __webpack_public_path__ + "static/media/window-close.99e24b044be2d332be0a3bc78d67f211.svg";
export { ForwardRef as ReactComponent };